function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnSize({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 137",
    d: "m25.55 18.21-2.12-2.13a.39.39 0 0 1 0-.56.4.4 0 0 1 .57 0l2.12 2.12 1.41-1.41-1.36-1.36a.39.39 0 0 1-.12-.28.4.4 0 0 1 .12-.29.42.42 0 0 1 .57 0l1.36 1.36 1.41-1.41-2.13-2.12a.4.4 0 1 1 .57-.57l2.12 2.12 1.25-1.24-3.71-3.71-.05-.05L21 15.25l-.56-.57 6.85-6.85a.4.4 0 0 1 .56 0l4.33 4.33a.4.4 0 0 1 0 .56l-6.85 6.85-.58-.57zm-10.87 2.22-6.85 6.85a.39.39 0 0 0 0 .56l4.33 4.33a.4.4 0 0 0 .56 0l6.85-6.85-.57-.57-.8.8-2.13-2.12a.4.4 0 0 0-.68.28.4.4 0 0 0 .12.29l2.12 2.12-1.41 1.41-1.36-1.36a.4.4 0 0 0-.28-.12.45.45 0 0 0-.29.12.42.42 0 0 0 0 .57l1.36 1.36-1.41 1.41-2.12-2.13a.43.43 0 0 0-.28-.11.44.44 0 0 0-.29.11.42.42 0 0 0 0 .57l2.12 2.12-1.24 1.25v-.05l-3.75-3.71L15.25 21zm-1.07-9.9-.76-.76a1.18 1.18 0 0 0-.85-.35.89.89 0 0 0-.63.25l-1.7 1.73a1 1 0 0 0 .1 1.45l.76.76zM25.15 28a.4.4 0 0 1 .11-.4.38.38 0 0 1 .39-.09l1 .28-.28-1a.4.4 0 0 1 .11-.4.37.37 0 0 1 .39-.09l.95.28-.28-1a.4.4 0 0 1 .49-.49l.25.06-14-14-3.18 3.03 14 14 .18.19zm4.74-.68a2.56 2.56 0 0 0-.39-.87l-.06-.06-1-.29.28 1a.39.39 0 0 1-.11.4.42.42 0 0 1-.4.1l-.94-.29.28 1a.4.4 0 0 1-.1.39.39.39 0 0 1-.41.1l-.94-.28.28 1a3.13 3.13 0 0 0 .87.38zm.7 3.42a.15.15 0 0 0 .11 0 .16.16 0 0 0 0-.16c-.19-.84-.37-1.59-.54-2.23v-.12l-2 2h.12c.65.17 1.4.35 2.23.54h.05M12 8.64a2 2 0 0 1 1.39.56l16.67 16.65.05-.05-.05.05c.21.21.56.56 1.45 4.51a.94.94 0 0 1-.24.9 1 1 0 0 1-.91.25c-3.95-.89-4.3-1.24-4.51-1.45L9.2 13.42a1.83 1.83 0 0 1-.1-2.58l1.73-1.74A1.68 1.68 0 0 1 12 8.64",
    style: {
      fill: "#5e5e5d"
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSize);
export default __webpack_public_path__ + "static/media/icn-size.a7d805379626d6b390ce9c64f239f3c7.svg";
export { ForwardRef as ReactComponent };